import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import useToggle from "../../../../hooks/toggle"
import { selecteddocumentesign } from "../ReviewDocs"
import Esign from "../Esign"
import { ALAPIA, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction"
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react"
const ALApropertyinspection= ()=>{
  const {id,user} : any = useParams()
  const componentRef = useRef();
const [pia,setPIA] = useState(
  {
    offer_id: id,
    purchase_aggrement_date: null,
    known_as: "",
    option_a1: "",
    option_a2: "",
    option_b1: "",
    option_b2: "",
    comments: "",
    option_c1: "",
    option_c2: "",
    buyer1_signature: "",
    buyer1_signature_date: null,
    buyer2_signature: "",
    buyer2_signature_date: null,
    seller1_signature: "",
    seller1_signature_date: null,
    seller2_signature: "",
    seller2_signature_date: null,
    hour: "",
    buyer_request_comments: ""
  }
)
const [loader,setloading] = useState(false)
 // @ts-ignore
 const val = useSelector((state)=>state?.new?.signset)
const [canvasmodal, setCanvasModal] = useToggle(false);
const [htmlContent, setHtmlContent] = useState("");
const [offerdetails, setOfferDetails] = useState({});
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid : "",
  document_name: "",
  image_base64: "",
  sign_role: 1
  })

  const printf = () => {
    // window.print()
    handlePrint()
};

useEffect(()=>{
  if(val){
    if(user == "seller"){
      setPIA({ ...pia, seller1_signature: val }) 
    }
    if(user == "client"){
      setPIA({ ...pia, buyer1_signature: val }) 
    }
  }
  },[val])

const send = async()=>{
  setloading(true)
  if(user === "seller"){

    if(pia?.seller1_signature){
      let res = await ALAPIA(pia)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  else if(user === "client"){

    if(pia?.buyer1_signature){
      let res = await ALAPIA(pia)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  setloading(false)
}

useEffect(()=>{
  (async function(){
    let offerdetails = await getSavedOfferDetails(id)
    setOfferDetails(offerdetails[0])
    const res =await getexternaldocuments(id,"piaproperty") 
    setPIA({...pia,
      purchase_aggrement_date: res?.data?.purchase_aggrement_date,
      known_as: res?.data?.known_as,
      option_a1: res?.data?.option_a1,
      option_a2: res?.data?.option_a2,
      option_b1: res?.data?.option_b1,
      option_b2: res?.data?.option_b2,
      comments: res?.data?.comments,
      option_c1: res?.data?.option_c1,
      option_c2: res?.data?.option_c2,
      buyer1_signature: res?.data?.buyer1_signature,
      buyer1_signature_date: res?.data?.buyer1_signature_date,
      buyer2_signature: res?.data?.buyer2_signature,
      buyer2_signature_date: res?.data?.buyer2_signature_date,
      seller1_signature: res?.data?.seller1_signature,
      seller1_signature_date: res?.data?.seller1_signature_date,
      seller2_signature: res?.data?.seller2_signature,
      seller2_signature_date: res?.data?.seller2_signature_date,
      hour: res?.data?.hour,
      buyer_request_comments: res?.data?.buyer_request_comments
    })
  })()
},[])

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});

    return(
      
        <>
  <section style={{ pageBreakAfter: "always" }} ref={componentRef}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                  <td>
                    <img
                      style={{ width: 30 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                      alt=""
                    />
                    <img
                      style={{ width: 50 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                      alt=""
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span style={{ fontSize: 20, fontWeight: 700 }}>
              Property Inspection Resolution Addendum
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              This addendum is addition to and becomes a permanent part of the
              Purchase Agreement dated
              <input
                type="date"
                value={pia?.purchase_aggrement_date}
                onChange={(e)=>setPIA({...pia,purchase_aggrement_date:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 250
                }}
              />
              on the property known as
              <input
                type="text"//@ts-ignore
                value={offerdetails?.propertyAddress}
                // onChange={(e)=>setPIA({...pia,known_as:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: "80%"
                }}
              />
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ paddingTop: 15 }}>
            <span>Purchase Agreement to be amended as follows:</span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>(Buyer(s) to initial the appropriate option)</span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              <input
                type="text"
                value={pia?.option_a1}
                onChange={(e)=>setPIA({...pia,option_a1:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              /
              <input
                type="text"
                value={pia?.option_a2}
                onChange={(e)=>setPIA({...pia,option_a2:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              <span style={{ fontWeight: 600 }}>Option “A”</span>-After
              inspections, the Buyer(s) removes the Property Inspections
              Contingency and agrees to accept the property in it’s current
              condition.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              <input
                type="text"
                value={pia?.option_b1}
                onChange={(e)=>setPIA({...pia,option_b1:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              /
              <input
                type="text"
                value={pia?.option_b2}
                onChange={(e)=>setPIA({...pia,option_b2:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              <span style={{ fontWeight: 600 }}>Option “B”</span>– After
              inspections, the Buyer(s) removes the Property Inspections
              contingency with the following items/issues to be addressed or
              repaired by the Seller as indicated below prior to closing.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              <span style={{ color: "#3b0083", fontWeight: 600 }}>
                {" "}
                <textarea
                   value={pia?.comments}
                   onChange={(e)=>setPIA({...pia,comments:e.target.value})}
                  style={{ width: "100%", height: 300, resize: "none" }}
                  defaultValue={""}
                />{" "}
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              <input
                type="text"
                value={pia?.option_c1}
                onChange={(e)=>setPIA({...pia,option_c1:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              /
              <input
                type="text"
                value={pia?.option_c2}
                onChange={(e)=>setPIA({...pia,option_c2:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              <span style={{ fontWeight: 600 }}>Option “C”</span> – The Property
              Inspections have been deemed to be unsatisfactory to Buyer(s). The
              Purchase Agreement shall be terminated and Buyer(s) shall be
              entitled to the return of the Deposit.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span>
                      <img
                    src={user === "client" ? val || pia?.buyer1_signature : pia?.buyer1_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Buyer </span>
                          </td>
                          <td>
                            <input type="date" 
                               value={pia?.buyer1_signature_date ? pia?.buyer1_signature_date  : (user === "client" && val || pia?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                               onChange={(e)=>setPIA({...pia,buyer1_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <span>
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Buyer </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.buyer2_signature}
                               onChange={(e)=>setPIA({...pia,buyer2_signature:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span style={{ color: "#3b0083" }}>
              Acknowledgement of receipt by Seller:
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span>
                      <img

src={user === "seller" ? val || pia?.seller1_signature : pia?.seller1_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Seller </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.seller1_signature_date ? pia?.seller1_signature_date : (user === "seller" && val || pia?.seller1_signature_date) ? new Date().toISOString().split('T')[0] : ""}
                               onChange={(e)=>setPIA({...pia,seller1_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <span>
                      <img
                     
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Sellar </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.seller2_signature_date}
                               onChange={(e)=>setPIA({...pia,seller2_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr style={{ padding: "15px 0px" }}>
          <td>
            <span style={{ fontWeight: 600 }}>
              SELLER RESPONSE TO ‘OPTION B’ REQUESTS ( IF APPLICABLE ):
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              Seller notifies Buyer that in response to Buyer’s ‘Option B’
              requests Seller:
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <ul>
              <li>
                Declines to take the requested action and unless Buyer accepts
                the Property “As Is” by the date calculated in the Purchase
                Agreement, this Purchase Agreement shall become null and void
                within 48 (or
                <input
                  type="text"
                  value={pia?.hour}
                  onChange={(e)=>setPIA({...pia,hour:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: 100
                  }}
                />{" "}
                ) hours of delivery of this notice to Buyer (or Buyer’s
                representative).
              </li>
              <li>Agrees to take the actions requested by Buyer</li>
              <li>
                Proposes to take the following action in response to Buyer’s
                Requests:
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              <textarea
                 value={pia?.buyer_request_comments}
                 onChange={(e)=>setPIA({...pia,buyer_request_comments:e.target.value})}
                style={{
                  width: "100%",
                  height: 300,
                  outline: "none",
                  resize: "none",
                  backgroundColor: "#e2e0f9"
                }}
                defaultValue={""}
              />
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span>
                      <img
                        src={user === "seller" ? val || pia?.seller1_signature : pia?.seller1_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Seller </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.seller1_signature_date ? pia?.seller1_signature_date  : (user === "seller" && val || pia?.seller1_signature_date) ? new Date().toISOString().split('T')[0] : ""}
                               onChange={(e)=>setPIA({...pia,seller1_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <span>
                      <img
                        src={pia?.seller2_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Sellar </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.seller2_signature_date}
                               onChange={(e)=>setPIA({...pia,seller2_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span style={{ color: "#3b0083", fontWeight: 600 }}>
              (This form is complete if Seller Declines and Buyer does not elect
              to take “As Is”, OR if Seller agrees to take all action requested
              by Buyer.)
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: 500, padding: "15px 0px" }}>
            <span>BUYER RESPONSE TO SELLER’S PROPOSED ACTIONS:</span>
          </td>
        </tr>
        <tr>
          <td>
            <ul>
              <li>Buyer accepts Seller’s proposed actions as satisfactory.</li>
              <li>
                Buyer rejects Seller’s proposed actions as unsatisfactory. This
                Purchase Agreement is null and void and Buyer is entitled to
                return of earnest money.
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span>
                      <img
                        src={user === "client" ? val || pia?.buyer1_signature : pia?.buyer1_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Buyer </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.buyer1_signature_date ? pia?.buyer1_signature_date : (user === "client" && val || pia?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                               onChange={(e)=>setPIA({...pia,buyer1_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <span>
                      <img
                        src={ pia?.buyer2_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Buyer </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.buyer2_signature_date }
                               onChange={(e)=>setPIA({...pia,buyer2_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span style={{ fontWeight: 600 }}>
              BUYER RESPONSE TO SELLER’S DECLINATION:
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <ul>
              <li>
                Buyer withdraws all requests for Seller to take action and
                elects to take the Property “As Is”, in the condition it was in
                at the time of the Purchase Agreement effective date.
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span>
                      <img
                       
                        src={user === "client" ? val || pia?.buyer1_signature : pia?.buyer1_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Buyer </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.buyer1_signature_date ? pia?.buyer1_signature_date: (user === "client" && val || pia?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                               onChange={(e)=>setPIA({...pia,buyer1_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <span>
                      <img
                         src={ pia?.buyer2_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid #3b0083",
                          width: "100px"
                        }}
                      />
                    </span>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <span>Buyer </span>
                          </td>
                          <td>
                          <input type="date" 
                               value={pia?.buyer2_signature_date}
                               onChange={(e)=>setPIA({...pia,buyer2_signature_date:e.target.value})}
                            />
                            date/time</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              Other provisions: Earnest deposit to be delivered within (5)
              business days.
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
<Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
</>

       
    )
}

export default ALApropertyinspection